import React from 'react';
import { TextFieldProps } from '../../types';

const TextField: React.FC<TextFieldProps> = ({
  value,
  onChange,
  placeholder = '',
  type = 'text',
  className = '',
  name,
  disabled,
  confidence,
  ...props
}) => {
  return (
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={`w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 ${className}`}
      name={name}
      disabled={disabled}
      {...props}
    />
  );
};

export default TextField;
